import { render, staticRenderFns } from "./Extrato.vue?vue&type=template&id=30dd53d6&scoped=true&"
import script from "./Extrato.vue?vue&type=script&lang=js&"
export * from "./Extrato.vue?vue&type=script&lang=js&"
import style0 from "./Extrato.vue?vue&type=style&index=0&id=30dd53d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd53d6",
  null
  
)

export default component.exports